import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { OFFER_STATUS_SELECTION } from '../../../../../../define/consts/rfp';
import { propArrayShape, propBool, propNumber, propShape, } from '../../../../../../helpers/custom-prop-types';
import HumanTalkIcon from '../../../../../Icon/Svg/HumanTalkIcon';
import NoteListIcon from '../../../../../Icon/Svg/NoteListIcon';
import OkIcon from '../../../../../Icon/Svg/OkIcon';
import ShakeHandOkIcon from '../../../../../Icon/Svg/ShakeHandOkIcon';
import DateText from '../../../../../Ui/Common/DateText';
import HtmlLink from '../../../../../Ui/Common/HtmlLink';
const RfpOneArrowLink = (props) => {
    const { activeIndex, isPreview, offers, rfp: { call_end_date: callEndDate, evaluation_deadline: evaluationDeadline, id, is_call_end: isCallEnd, is_interview_view: isInterviewView, start_date: startDate, }, } = props;
    const lists = useMemo(() => {
        const interviews = offers.filter((v) => v.offer.interview_status);
        const isAllInterviewAnswered = interviews.length > 0 &&
            offers.every((v) => v.offer.status !== OFFER_STATUS_SELECTION.value);
        return [
            {
                format: 'M月D日 23:59',
                icon: _jsx(NoteListIcon, {}),
                isLink: !isPreview,
                label: '募集期限',
                step: 1,
                title: '提案を集める',
                url: `/project/client/${id}/offer`,
                value: callEndDate,
            },
            {
                format: 'M月D日 23:59',
                icon: _jsx(HumanTalkIcon, {}),
                isLink: !isPreview && (offers.length > 0 || isCallEnd),
                label: '選定期限',
                step: 2,
                title: '面談先を決める',
                url: offers.length === 0 || !isInterviewView
                    ? `/project/client/${id}/interview`
                    : `/project/client/${id}/interview/view`,
                value: evaluationDeadline,
            },
            {
                format: 'M月D日頃',
                icon: _jsx(ShakeHandOkIcon, {}),
                isLink: !isPreview && isAllInterviewAnswered,
                label: '選定期限',
                step: 3,
                title: '発注先を決める',
                url: `/project/client/${id}/order`,
                value: startDate,
            },
        ];
    }, [
        id,
        isCallEnd,
        isPreview,
        callEndDate,
        evaluationDeadline,
        startDate,
        offers,
        isInterviewView,
    ]);
    return (_jsx("div", Object.assign({ className: 'rfp-arrow-link' }, { children: _jsx("div", Object.assign({ className: 'steps' }, { children: lists.map((row) => (_jsxs(HtmlLink, Object.assign({ className: clsx('step', `step${row.step}`, {
                    active: row.step === activeIndex,
                    after: row.step > activeIndex,
                    before: row.step < activeIndex,
                }), isNoLinkComponent: row.isLink ? undefined : 'div', to: row.url }, { children: [_jsx("div", { className: 'step_before' }), _jsxs("div", Object.assign({ className: 'step-inner' }, { children: [_jsx("div", Object.assign({ className: 'step-inner-icon' }, { children: activeIndex > row.icon ? _jsx(OkIcon, {}) : row.icon })), _jsxs("div", Object.assign({ className: 'step-inner-body' }, { children: [_jsx("p", Object.assign({ className: 'wbr title_row' }, { children: row.title })), _jsxs("p", Object.assign({ className: 'value_row' }, { children: [_jsx("span", Object.assign({ className: 'label_text' }, { children: `${row.label}：` })), _jsx("span", Object.assign({ className: 'value_text' }, { children: _jsx(DateText, { defaultText: '-', format: row.format, value: row.value }) }))] }))] }))] })), _jsx("div", { className: 'step_after' })] }), row.step))) })) })));
};
RfpOneArrowLink.propTypes = {
    activeIndex: propNumber().isRequired,
    isPreview: propBool(),
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
RfpOneArrowLink.defaultProps = {
    isPreview: false,
};
export default RfpOneArrowLink;
